module.exports = __webpack_public_path__ + "img/brand-concept.c045fdec.jpg";